import classNames from 'classnames'
import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import EmptyBlock from '../../components/common/EmptyBlock'
import EmptyPage from '../../components/common/EmptyPage'
import MediaTab from '../../components/common/material/MediaTab'
import useIsAdminLogin from '../../modules/hooks/common/useIsAdminLogin'
import { s_materials, s_preparation } from '../../modules/i18n/strings/auto/wording'
import useTranslation from '../../modules/i18n/useTranslation'
import { track } from '../../modules/track'
import { LOCATION, LOG_CATEGORY, LOG_TYPE } from '../../modules/vars'

interface MediaPanelType {
  media: any
  noMedia: boolean
  course?: any
  checkYoutube?: any
  className?: string
  isLesson?: boolean
}
const MediaPanel: React.FC<MediaPanelType> = ({ media, noMedia, course, checkYoutube, className, isLesson }) => {
  const { t } = useTranslation()
  const getDefaultIsPlaying = () => {
    if (media && media.youtubes?.length > 0) {
      return media.youtubes.map((item) => false)
    }
    return []
  }
  const getDefaultMediaLogId = () => {
    if (media && media.youtubes?.length > 0) {
      return media.youtubes.map((item) => null)
    }
    return []
  }

  const getDefaultMediaPlayback = () => {
    if (media && media.youtubes?.length > 0) {
      return media.youtubes.map((item) => null)
    }
    return []
  }
  const getDefaultMediaDuration = () => {
    if (media && media.youtubes?.length > 0) {
      return media.youtubes.map((item) => null)
    }
    return []
  }

  const [mediaLogId, setMediaLogId] = useState(getDefaultMediaLogId())
  const [mediaPlaybackTime, setMediaPlaybackTime] = useState(getDefaultMediaPlayback())
  const [mediaDuration, setMediaDuration] = useState(getDefaultMediaDuration())
  const [isPlaying, setIsPlaying] = useState(getDefaultIsPlaying())
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    setIsMobile(window.innerWidth < 576 ? true : false)
  }, [])

  const handleMediaOnPlay = (i, playbackTime) => {
    const tempIsPlaying = [...isPlaying]
    tempIsPlaying[i] = true
    setIsPlaying(tempIsPlaying)
    const tempPlayback = [...mediaPlaybackTime]
    tempPlayback[i] = playbackTime
    setMediaPlaybackTime(tempPlayback)
  }
  const handleMediaOnPause = (i) => {
    const temp = [...isPlaying]
    temp[i] = false
    setIsPlaying(temp)
  }
  const handleMediaOnEnd = (i) => {
    const temp = [...isPlaying]
    temp[i] = false
    setIsPlaying(temp)
    toast(t(s_preparation.clipComplete))
  }
  const isAdminLogin = useIsAdminLogin()
  const handleArticleClick = (item) => {
    if (isAdminLogin) return
    track({
      location: LOCATION.COURSE,
      log_type: LOG_TYPE.COURSE.ARTICLE,
      log_category: LOG_CATEGORY.READ,
      course_id: course.id,
      article_id: item.id,
    })
  }
  useEffect(() => {
    const tempLogId = [...mediaLogId]
    const tempPlayback = [...mediaPlaybackTime]
    const tempDuration = [...mediaDuration]
    isPlaying.forEach((item, i) => {
      if (!item) {
        const timeout = setTimeout(() => {
          if (!isPlaying[i] && mediaPlaybackTime[i] != null) {
            tempLogId[i] = null
            tempPlayback[i] = null
            tempDuration[i] = null
            setMediaDuration(tempDuration)
            setMediaLogId(tempLogId)
            setMediaPlaybackTime(tempPlayback)
          }
        }, 1000)
        return () => clearTimeout(timeout)
      }
    })
  }, [...isPlaying])

  useEffect(() => {
    const tempLogId = [...mediaLogId]
    const tempDuration = [...mediaDuration]
    const interval = setInterval(() => {
      mediaPlaybackTime.forEach((playBack, i) => {
        const logId = tempLogId[i]
        let duration = tempDuration[i] || 0
        duration += 1
        if (playBack != null) {
          if (duration >= 5) {
            tempDuration[i] = duration
            track({
              location: LOCATION.COURSE,
              log_type: LOG_TYPE.COURSE.VIDEO,
              log_category: LOG_CATEGORY.LISTEN,
              course_id: course?.id,
              youtube_id: media.youtubes[i].id,
              log_id: logId,
              duration: duration,
              playback_time: mediaPlaybackTime[i] + duration,
            }).then((res) => {
              if (!logId) {
                tempLogId[i] = res?.log?.id
              }
            })
          }
          tempDuration[i] = duration
        }
      })
      setMediaLogId(tempLogId)
      setMediaDuration(tempDuration)
    }, 1000)
    return () => {
      clearInterval(interval)
    }
  }, [...mediaPlaybackTime])

  return (
    <div
      style={{ minHeight: !isLesson ? 'calc(100vh - 120px)' : '' }}
      className={classNames(className, 'no-scrollbar pt-[32px] text-black')}
    >
      <div>
        {noMedia ? (
          <EmptyPage title={t(s_materials.does_not_include_video_article)} />
        ) : (
          media && (
            <MediaTab
              isMobile={isMobile}
              media={media}
              checkYoutube={() => checkYoutube()}
              onPlay={handleMediaOnPlay}
              onPause={handleMediaOnPause}
              onArticleClick={handleArticleClick}
              onEnd={handleMediaOnEnd}
            />
          )
        )}
        <EmptyBlock h={80} />
      </div>
    </div>
  )
}

export default MediaPanel
